import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "button-placeholder"
}
const _hoisted_2 = { class: "media-title" }
const _hoisted_3 = { class: "timeline-wrapper" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "current" }
const _hoisted_6 = { class: "length" }
const _hoisted_7 = { class: "media-timer-timer" }
const _hoisted_8 = { class: "volume-container" }

import { ref, onMounted, watch, nextTick } from "vue";
import { getTimeCodeFromNum } from "../../assets/helpers_legacy";
import IconButton from "../IconButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaControlBar',
  props: {
  mediaComponent: {
    type: HTMLMediaElement,
    default: null,
  },
  mediaType: {
    type: String,
    default: "audio",
  },
  audioVisualization: Boolean,
  mediaPaused: Boolean,
  setPlaybackSpeed: {
    type: Function,
    default: () => {},
  },
  MEDIA_SKIP_AMOUNT: {
    type: Number,
    default: 10,
  },
  insertCurrentTimestamp: Function,
  mediaName: String,
  isInfoPanelOpen: Boolean,
  addBookmark: {
    type: Function,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "updateShowAudioVisualization",
  "updateCurrentTime",
  "toggleAudioVisualization",
],
  setup(__props, { emit: __emit }) {

const VolumeOnWhiteIcon = require("../../assets/images/Volume-on-white.svg") as string;
const VolumeMutedWhiteIcon = require("../../assets/images/Volume-muted-white.svg") as string;
const Rewind10WhiteIcon = require("../../assets/images/Rewind-10-white.svg") as string;
const SkipForward10WhiteIcon = require("../../assets/images/Skip-forward-10-white.svg") as string;
const PlayWhiteIcon = require("../../assets/images/Play-white.svg") as string;
const PauseWhiteIcon = require("../../assets/images/Pause-white.svg") as string;
const PlaybackSpeedWhiteIcon = require("../../assets/images/Playback-speed-white.svg") as string;
const AudioVisualizationWhiteIcon = require("../../assets/images/Audio-visualization-white.svg") as string;
const TimestampWhiteIcon = require("../../assets/images/Timestamp-white.svg") as string;
const BookmarkIcon = require("../../assets/images/Bookmark-white.svg") as string;

const props = __props

const currentTime = ref("0:00");
const previewTime = ref("");
const totalLength = ref("");
const mediaComponent = ref(props.mediaComponent);
const isMuted = ref(mediaComponent.value.muted);
const isPaused = ref(mediaComponent.value.paused);
const showAudioVisualization = ref(props.audioVisualization);
const mediaPlayer = ref(null);

// template refs
const controls = ref<HTMLDivElement|null>(null);
const volumeSlider = ref<HTMLDivElement|null>(null);
const timeline = ref<Element|null>(null);
const timePreview = ref<HTMLDivElement|null>(null);
const progressBar = ref<HTMLDivElement|null>(null);
const volumePercentage = ref<HTMLDivElement|null>(null);

const playbackSpeedMenu = ref<HTMLDivElement|null>(null);

const emit = __emit;

function openPlaybackSpeedMenu() {
  nextTick(() => {
    if (playbackSpeedMenu.value) {
      if (playbackSpeedMenu.value.style.display === "flex") {
        playbackSpeedMenu.value.style.display = "none";
      } else {
        playbackSpeedMenu.value.style.display = "flex";
      }
    }
  });
}

function handleKeyForPlaybackSpeedMenu(event: KeyboardEvent) {
  if (playbackSpeedMenu.value) {
    if (event.key === "Enter"  || event.key === "ArrowDown") {
      event.preventDefault();
        playbackSpeedMenu.value.style.display = "flex";
        playbackSpeedMenu.value.blur();
        (document.querySelectorAll(".dropdown-menu-button")[0] as HTMLElement).focus();
    }
  }
}

function handleKeyForSetPlaybackSpeed(event: KeyboardEvent, speed: number) {
  if (playbackSpeedMenu.value) {  
    if (event.key === "Enter") {
      event.preventDefault();
      setPlaybackSpeed(speed);
      playbackSpeedMenu.value.style.display = "none";
    }

    if (event.key === "Escape") {
      event.preventDefault();
      playbackSpeedMenu.value.style.display = "none";
    }

    if (event.key === "ArrowDown") {
      event.preventDefault();
      const nextButton = ((event.target as HTMLElement).nextElementSibling) as HTMLButtonElement;
      if (nextButton) {
        nextButton.focus();
      }
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      const previousButton = ((event.target as HTMLElement).previousElementSibling) as HTMLButtonElement;
      if (previousButton) {
        previousButton.focus();
      }
    }
  }
}

function toggleMuted() {
  mediaComponent.value.muted = !mediaComponent.value.muted;
}

function togglePlay() {
  if (mediaComponent.value.paused) {
    mediaComponent.value.play();
    isPaused.value = false;
  } else {
    mediaComponent.value.pause();
    isPaused.value = true;
  }
}

watch(() => props.mediaComponent, function (newComponent: HTMLMediaElement) {
  if (newComponent) {
    mediaComponent.value = newComponent;
    currentTime.value = getTimeCodeFromNum(mediaComponent.value.currentTime);
    setupMediaListeners();
  }
})

function toggleAudioVisualization() {
  showAudioVisualization.value = !showAudioVisualization.value;
  emit("updateShowAudioVisualization", showAudioVisualization.value);
}

function skipForward() {
  mediaComponent.value.currentTime += props.MEDIA_SKIP_AMOUNT;
}

function skipBackward() {
  mediaComponent.value.currentTime -= props.MEDIA_SKIP_AMOUNT;
}

function clickOnSlider(evt: Event) {
  if (volumeSlider.value) {
    const sliderWidth = window.getComputedStyle(volumeSlider.value).width;
    const newVolume = (evt as MouseEvent).offsetX / parseInt(sliderWidth);
    mediaComponent.value.volume = newVolume;
    if (volumePercentage.value) {
      volumePercentage.value.style.width = newVolume * 100 + "%";
    }
  }
}

function setPlaybackSpeed(playbackSpeed: number) {
  mediaComponent.value.playbackRate = playbackSpeed;
}

function setupMediaListeners() {
  if (totalLength.value === "") {
    mediaComponent.value.addEventListener(
      "loadeddata",
      () => {
        totalLength.value = getTimeCodeFromNum(mediaComponent.value.duration);
        mediaComponent.value.volume = 0.75;
      },
      false,
    );
  }

  mediaComponent.value.addEventListener(
    "timeupdate",
    () => {
      currentTime.value = getTimeCodeFromNum(mediaComponent.value.currentTime);
    },
    false,
  );

  mediaComponent.value.addEventListener(
    "pause",
    () => {
      isPaused.value = mediaComponent.value.paused;
    },
    false,
  );

  mediaComponent.value.addEventListener(
    "play",
    () => {
      isPaused.value = mediaComponent.value.paused;
    },
    false,
  );
}

onMounted(() => {
    if (props.mediaType === "video") {
      emit("updateShowAudioVisualization", true);
    }

    setupMediaListeners();

    //click on timeline to skip around
    if (timeline.value !== null) {
      timeline.value.addEventListener(
        "click",
        (e) => {
          if (timeline.value) {
            const timelineWidth = window.getComputedStyle(timeline.value).width;
            const timeToSeek =
              ((e as MouseEvent).offsetX / parseInt(timelineWidth)) * mediaComponent.value.duration;
            emit("updateCurrentTime", timeToSeek);
          }
        },
        false
      );

      timeline.value.addEventListener(
        "mouseleave",
        () => {
          if (timePreview.value) {
            timePreview.value.style.opacity = "0";
          }
        },
        false
      );

      timeline.value.addEventListener(
        "mousemove",
        (e) => {
          if (timeline.value && timePreview.value) {
            const timelineWidth = window.getComputedStyle(timeline.value).width;
            const positionPercentage = (e as MouseEvent).offsetX / parseInt(timelineWidth);
            timePreview.value.style.left = positionPercentage * 100 + "%";
            timePreview.value.style.opacity = "1";
            const timeToSeek = positionPercentage * mediaComponent.value.duration;
            previewTime.value = getTimeCodeFromNum(timeToSeek);
          }
        },
        false
      );

    }

    setInterval(() => {
      if (progressBar.value) {
        progressBar.value.style.width =
        (mediaComponent.value.currentTime / mediaComponent.value.duration) * 100 +
        "%";
      currentTime.value = getTimeCodeFromNum(mediaComponent.value.currentTime);
      }
    }, 500);
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "media-player",
    ref_key: "mediaPlayer",
    ref: mediaPlayer
  }, [
    _createElementVNode("section", {
      role: "region",
      title: "Audio controls",
      "aria-label": "Audio Controls",
      class: "controls",
      ref_key: "controls",
      ref: controls
    }, [
      (!__props.isInfoPanelOpen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(IconButton, {
        icon: _unref(Rewind10WhiteIcon),
        alt: "Rewind media",
        onclick: skipBackward,
        xsmall: "",
        enterPress: skipBackward,
        ariaLabel: "Rewind media",
        disabled: __props.disabled
      }, null, 8, ["icon", "disabled"]), [
        [
          _directive_tooltip,
          'Rewind ' + __props.MEDIA_SKIP_AMOUNT + 's',
          void 0,
          { top: true }
        ]
      ]),
      _withDirectives(_createVNode(IconButton, {
        icon: isPaused.value && __props.mediaPaused ? _unref(PlayWhiteIcon) : _unref(PauseWhiteIcon),
        alt: "Toggle media playing",
        onclick: togglePlay,
        xsmall: "",
        enterPress: togglePlay,
        ariaLabel: isPaused.value ? 'Play media' : 'Pause media',
        disabled: __props.disabled
      }, null, 8, ["icon", "ariaLabel", "disabled"]), [
        [
          _directive_tooltip,
          isPaused.value ? 'Play' : 'Pause',
          void 0,
          { top: true }
        ]
      ]),
      _withDirectives(_createVNode(IconButton, {
        icon: _unref(SkipForward10WhiteIcon),
        alt: "Fast forward media",
        onclick: skipForward,
        xsmall: "",
        enterPress: skipForward,
        ariaLabel: "Fast forward media",
        disabled: __props.disabled
      }, null, 8, ["icon", "disabled"]), [
        [
          _directive_tooltip,
          'Skip forward ' + __props.MEDIA_SKIP_AMOUNT + 's',
          void 0,
          { top: true }
        ]
      ]),
      (__props.mediaType !== 'video')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["media-timeline", __props.isInfoPanelOpen && 'shrink'])
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.mediaName), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(currentTime.value), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(totalLength.value), 1)
              ]),
              _createElementVNode("div", {
                class: "timeline",
                ref_key: "timeline",
                ref: timeline
              }, [
                _createElementVNode("div", {
                  class: "time-preview",
                  ref_key: "timePreview",
                  ref: timePreview
                }, _toDisplayString(previewTime.value), 513),
                _createElementVNode("div", {
                  class: "progress",
                  ref_key: "progressBar",
                  ref: progressBar
                }, null, 512)
              ], 512)
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["media-timer", __props.disabled && 'disabled'])
      }, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(`${currentTime.value} / ${totalLength.value}`), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["button-with-dropdown-attached gap", __props.disabled && 'disabled'])
      }, [
        _withDirectives(_createVNode(IconButton, {
          icon: _unref(PlaybackSpeedWhiteIcon),
          alt: "Playback speed",
          xsmall: "",
          ariaLabel: "Playback speed",
          disabled: __props.disabled,
          onClick: openPlaybackSpeedMenu,
          enterPress: handleKeyForPlaybackSpeedMenu
        }, null, 8, ["icon", "disabled"]), [
          [
            _directive_tooltip,
            'Playback speed',
            void 0,
            { top: true }
          ]
        ]),
        (!__props.disabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "playbackSpeedMenu",
              ref: playbackSpeedMenu,
              class: "dropdown-menu right"
            }, [
              _createElementVNode("button", {
                autofocus: true,
                class: "dropdown-menu-button text-normal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setPlaybackSpeed(0.25))),
                "aria-label": "0.25",
                onKeydown: _cache[1] || (_cache[1] = ($event: any) => (handleKeyForSetPlaybackSpeed($event, 0.25)))
              }, " 0.25x ", 32),
              _createElementVNode("button", {
                class: "dropdown-menu-button text-normal",
                "aria-label": "0.5",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (setPlaybackSpeed(0.5))),
                onKeydown: _cache[3] || (_cache[3] = ($event: any) => (handleKeyForSetPlaybackSpeed($event, 0.5)))
              }, " 0.5x ", 32),
              _createElementVNode("button", {
                class: "dropdown-menu-button text-normal",
                "aria-label": "1",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (setPlaybackSpeed(1))),
                onKeydown: _cache[5] || (_cache[5] = ($event: any) => (handleKeyForSetPlaybackSpeed($event, 1)))
              }, " 1x ", 32),
              _createElementVNode("button", {
                class: "dropdown-menu-button text-normal",
                "aria-label": "2",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (setPlaybackSpeed(2))),
                onKeydown: _cache[7] || (_cache[7] = ($event: any) => (handleKeyForSetPlaybackSpeed($event, 2)))
              }, " 2x ", 32),
              _createElementVNode("button", {
                class: "dropdown-menu-button text-normal",
                "aria-label": "3",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (setPlaybackSpeed(3))),
                onKeydown: _cache[9] || (_cache[9] = ($event: any) => (handleKeyForSetPlaybackSpeed($event, 3)))
              }, " 3x ", 32)
            ], 512))
          : _createCommentVNode("", true)
      ], 2),
      (__props.mediaType !== 'video')
        ? _withDirectives((_openBlock(), _createBlock(IconButton, {
            key: 2,
            icon: _unref(AudioVisualizationWhiteIcon),
            alt: "Audio visualization",
            onclick: toggleAudioVisualization,
            xsmall: "",
            enterPress: toggleAudioVisualization,
            ariaLabel: showAudioVisualization.value ? 'Hide audio visualization' : 'Show audio visualization',
            disabled: __props.disabled
          }, null, 8, ["icon", "ariaLabel", "disabled"])), [
            [
              _directive_tooltip,
              'Audio visualization',
              void 0,
              { top: true }
            ]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createVNode(IconButton, {
          icon: isMuted.value ? _unref(VolumeMutedWhiteIcon) : _unref(VolumeOnWhiteIcon),
          alt: "Play Media",
          onclick: toggleMuted,
          xsmall: "",
          enterPress: toggleMuted,
          ariaLabel: isMuted.value ? 'Unmute media' : 'Mute media',
          disabled: __props.disabled
        }, null, 8, ["icon", "ariaLabel", "disabled"]), [
          [
            _directive_tooltip,
            'Volume',
            void 0,
            { top: true }
          ]
        ]),
        (!__props.disabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "volume-slider",
              ref_key: "volumeSlider",
              ref: volumeSlider,
              onClick: clickOnSlider
            }, [
              _createElementVNode("div", {
                class: "volume-percentage",
                ref_key: "volumePercentage",
                ref: volumePercentage
              }, null, 512)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      (__props.mediaType !== 'video')
        ? _withDirectives((_openBlock(), _createBlock(IconButton, {
            key: 3,
            icon: _unref(TimestampWhiteIcon),
            alt: "Insert Timestamp",
            class: "text-formatting-button",
            xsmall: "",
            onclick: __props.insertCurrentTimestamp,
            enterPress: __props.insertCurrentTimestamp,
            ariaLabel: "Insert current timestamp",
            disabled: __props.disabled
          }, null, 8, ["icon", "onclick", "enterPress", "disabled"])), [
            [
              _directive_tooltip,
              'Insert timestamp',
              void 0,
              { top: true }
            ]
          ])
        : _createCommentVNode("", true),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "split-line" }, null, -1)),
      _withDirectives(_createVNode(IconButton, {
        "v-if": __props.addBookmark !== null,
        icon: _unref(BookmarkIcon),
        alt: "Bookmark",
        class: "text-formatting-button",
        xsmall: "",
        onclick: __props.addBookmark,
        enterPress: __props.addBookmark,
        ariaLabel: "Add bookmark",
        disabled: __props.disabled
      }, null, 8, ["v-if", "icon", "onclick", "enterPress", "disabled"]), [
        [
          _directive_tooltip,
          'Bookmark',
          void 0,
          { top: true }
        ]
      ])
    ], 512)
  ], 512))
}
}

})